import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["test", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var queryReducer = function queryReducer(query) {
  var initialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (width, height) {
    return query.filter(function (_ref) {
      var test = _ref.test;
      return test(width, height);
    })
    // omiting test & children
    .reduce(function (acc, _ref2) {
      var test = _ref2.test,
        children = _ref2.children,
        props = _objectWithoutProperties(_ref2, _excluded);
      return _objectSpread(_objectSpread({}, acc), props);
    }, initialValues);
  };
};
export var adjustFramesDimensions = function adjustFramesDimensions(getProps) {
  return function (width) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    var props = getProps.apply(void 0, [width].concat(params));
    var framesPerSlide = props.framesPerSlide,
      gutter = props.gutter,
      frameWidth = props.frameWidth;
    if (frameWidth) {
      var calculatedFramesPerSlide = Math.floor(width / frameWidth);
      return _objectSpread(_objectSpread({}, props), {}, {
        framesPerSlide: calculatedFramesPerSlide,
        gutter: gutter || width % frameWidth / (calculatedFramesPerSlide - 1)
      });
    }
    return _objectSpread(_objectSpread({}, props), {}, {
      frameWidth: (width - (framesPerSlide - 1) * gutter) / framesPerSlide
    });
  };
};

/** @deprecated Will be removed in v2.0.0 */
var convertDurationToNumber = function convertDurationToNumber(value) {
  if (typeof value === 'string') {
    return value.replace(/(ms|s|m)([0-9])/gi, '$1 $2').replace(/\s+/gi, ' ').split(' ').map(function (time) {
      var _time$replace$split = time.replace(/([0-9])(ms|s|m)/gi, '$1 $2').split(' '),
        _time$replace$split2 = _slicedToArray(_time$replace$split, 2),
        amount = _time$replace$split2[0],
        type = _time$replace$split2[1];
      var result = amount || 0;
      /* eslint-disable no-fallthrough */
      switch (type) {
        case 'm':
          result *= 60;
        case 's':
          result *= 1000;
        case 'ms':
        default:
          result *= 1;
      }
      /* eslint-enable no-fallthrough */
      return result;
    }).reduce(function (acc, next) {
      return acc + next;
    });
  }
  return value;
};

/** @deprecated Will be removed in v2.0.0 */
export var adjustDurationToNumber = function adjustDurationToNumber(getProps) {
  return function () {
    var props = getProps.apply(void 0, arguments);
    return _objectSpread(_objectSpread({}, props), {}, {
      autoSwitchTime: convertDurationToNumber(props.autoSwitchTime),
      transitionDuration: convertDurationToNumber(props.transitionDuration)
    });
  };
};

/** @deprecated Will be removed in v2.0.0 */
export var adjustRemoveNoTransition = function adjustRemoveNoTransition(getProps) {
  return function () {
    var props = getProps.apply(void 0, arguments);
    return _objectSpread(_objectSpread({}, props), {}, {
      transitionDuration: props.noTransition ? 0 : props.transitionDuration || 0
    });
  };
};